import React from "react";
import { Alert, AlertTitle, Box } from "@mui/material";

/**
 * Displayed on any page/component whose API returned empty data.
 * Shown instead of the normal page content.
 */
const ContentUnavailable = ({ page }) => (
  <Box sx={{ p: 3 }}>
    <Alert severity="error" variant="filled">
      <AlertTitle sx={{ fontFamily: "Montserrat", fontWeight: 700 }}>
        Content Unavailable{page ? ` — ${page}` : ""}
      </AlertTitle>
      <span style={{ fontFamily: "Montserrat" }}>
        Content currently unavailable, please contact site administrator.
      </span>
    </Alert>
  </Box>
);

export default ContentUnavailable;
